import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  GET_LIST_ALL_QUESTIONS_REQUEST,
  GET_LIST_ALL_QUESTIONS_SUCCESS,
  SEARCH,
  SAVE_CLIENT_CHECKLIST_REQUEST,
  SAVE_CLIENT_CHECKLIST_SUCCESS,
  SET_LOADING_SEND,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  SET_LOADING_MODAL_QUESTION,
  EDIT_ITEM,
  DELETE_ITEM
} from './client-checklist-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const setLoadingModalQuestion = (loading: Boolean) => {
  return {
    type: SET_LOADING_MODAL_QUESTION,
    loading
  };
};

export const getAllChecklistRequest = () => {
  return {
    type: GET_LIST_ALL_QUESTIONS_REQUEST
  };
};

export const getAllChecklistSuccess = payload => {
  return {
    type: GET_LIST_ALL_QUESTIONS_SUCCESS,
    payload
  };
};

export const editItem = (id: string) => {
  return {
    type: EDIT_ITEM,
    id
  };
};

export const deleteItem = (id: string) => {
  return {
    type: DELETE_ITEM,
    id
  };
};

export const getByIdRequest = (id: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const saveClientChecklistRequest = (payload: any, id?: string) => {
  return {
    type: SAVE_CLIENT_CHECKLIST_REQUEST,
    payload,
    id
  };
};

export const saveClientChecklistSucess = (payload: any) => {
  return {
    type: SAVE_CLIENT_CHECKLIST_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};
